import { render, staticRenderFns } from "./SortByControl.vue?vue&type=template&id=9e1a89a6&"
import script from "./SortByControl.vue?vue&type=script&lang=js&"
export * from "./SortByControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports